import * as React from "react";
import { DropdownMenu } from "@conserveit/blocks";
import { DataSource } from "../types";
import * as Chart from "../../ChartZone.styles";
import { MultiSeriesColumnChart } from "../../../Charts/components/MultiSeriesColumnChart";
import { useState as useUtilitiesState } from "../../../../context/reports/utilities";
import { MetricsType } from "../../../../context/reports/utilities/types";
import { Sorting } from "../../../../context/reports/types";
import { useTrackedActions } from "../hooks/useTrackedActions";
import { ChartLoader } from "../../../Charts/components/ChartLoader";
import { NoResult } from "../../";
import { Margin } from "../../../Layout/Page";

interface Props {
  dataSource: DataSource;
  type: MetricsType;
  unit: string;
  loading?: boolean;
}

export const RankedSitesFrame: React.FC<Props> = ({
  dataSource,
  type,
  unit,
  loading = true,
}) => {
  const state = useUtilitiesState();
  const { trackedRankedSitesOrderBy } = useTrackedActions();

  const chartTitle = `Individual site ${type.toLowerCase()} consumption`;

  return (
    <Chart.Container>
      <Chart.Block>
        <Chart.Header>
          <Chart.Heading>
            <Chart.Title>{chartTitle}</Chart.Title>
            <Chart.Subtitle>
              Showing annual consumption compared to previous years
            </Chart.Subtitle>
          </Chart.Heading>
          <Chart.Controls>
            <DropdownMenu
              right
              trigger="Order"
              defaultValue={state.sortingDirection.rankedSites}
              value={state.sortingDirection.rankedSites}
              onSelect={trackedRankedSitesOrderBy(chartTitle)}
              options={[
                { value: Sorting.Desc, label: "Most to Least (YTD)" },
                { value: Sorting.Asc, label: "Least to Most (YTD)" },
              ]}
            />
          </Chart.Controls>
        </Chart.Header>
        <Chart.Content>
          {loading ? (
            <ChartLoader />
          ) : dataSource.series.length !== 0 ? (
            <Margin>
              <MultiSeriesColumnChart
                key={type}
                dataSource={dataSource}
                valueDecimals={2}
                valueSuffix={" " + unit}
                yAxisTitle="Consumption (kWh)"
              />
            </Margin>
          ) : (
            <NoResult />
          )}
        </Chart.Content>
      </Chart.Block>
    </Chart.Container>
  );
};
